// extracted by mini-css-extract-plugin
export default {"nutrition-info-table":"NutritionInfosSection__nutrition-info-table--Jmrok","nutritionInfoTable":"NutritionInfosSection__nutrition-info-table--Jmrok"};